import { InsuranceType } from "@gtpl/shared-models/common-models";

export class InsuranceTypeRequest{
    insuranceType : InsuranceType;
    
    constructor(insuranceType:InsuranceType){
        this.insuranceType = insuranceType
    }
}
